import { Component } from '@angular/core';

@Component({
  selector: 'app-cookie-policies',
  templateUrl: './cookie-policies.component.html',
  styleUrls: ['./cookie-policies.component.scss']
})
export class CookiePoliciesComponent {

}
